import React from 'react';
import swal from 'sweetalert';

import I18n from '../../locales/i18n';

const ChangeText = ({ children, name, dbName, setParam }) => {
	const [isLoading, setLoadingStatus] = React.useState(false);

	const onSubmit = (e) => {
		e.preventDefault();
		const control = e.target.elements[name];
		let value = control.value;
		if (dbName === 'customLink') {
			value = `https://${value}`;
		}
		setParam({ [dbName]: value })
			.then(() => {
				swal('', I18n('MY_BRAND', 'TEXT_SAVED_SUCCESS'), 'success').then(() => {
					setLoadingStatus(false);
				});
			})
			.catch((error) => {
				console.error(error);
				swal('Error', I18n('MY_BRAND', 'TEXT_SAVED_ERROR'), 'error').then(
					() => {
						setLoadingStatus(false);
					}
				);
			});
	};
	return (
		<form onSubmit={onSubmit} style={{ display: 'flex', flexDirection: 'row' }}>
			<div style={{ width: 'calc(100% - 100px)' }}>{children}</div>
			<button disabled={isLoading} className="btn btn-success">
				<i className={'fas fa-' + (isLoading ? 'spinner fa-spin' : 'save')} />{' '}
				{isLoading ? I18n('COMMON', 'SAVING') : I18n('COMMON', 'SAVE')}{' '}
			</button>
		</form>
	);
};

export default ChangeText;
